import React from 'react';
import { ButtonGroup, Button, Center } from '@chakra-ui/react';
import { useCustomer, useForgotPassword, useLogout } from '@olo-web/domain/customer';
import { useRouter } from 'next/router';
import { useIsDineIn, useToast } from '@olo-web/utils/common/hooks';
import { useCurrentMerchantPath } from '@olo-web/utils/common/hooks';
import { useAlertDispatch, useScreenSizeState } from '@olo-web/client-state';
import { EAlertTypes } from '@olo-web/types/enums';

export const AccountBottomButtons = () => {
  const { data: customer } = useCustomer();
  const isDineIn = useIsDineIn();
  const { notify } = useToast();
  const router = useRouter();
  const menuPath = useCurrentMerchantPath({ includeQueryParam: !isDineIn });
  const alertDispatch = useAlertDispatch();
  const { isSmDown } = useScreenSizeState();

  const { isLoading, mutate: sendForgotPasswordEmail } = useForgotPassword({
    onSuccess: () => {
      notify({
        status: 'success',
        description: 'You should see the reset password email in your inbox shortly',
        variant: 'left-accent',
        position: 'top',
        isClosable: true,
        duration: null,
      });
    },
    onError: (error) => {
      notify({
        status: 'error',
        title: 'Password reset email not sent',
        description: error?.message || 'Please try again',
        variant: 'left-accent',
        position: 'top',
      });
    },
  });

  const { mutate: logOut } = useLogout({
    onSuccess: () => {
      router.push(menuPath);
    },
  });
  return (
    <Center>
      <ButtonGroup
        variant="ghost"
        colorScheme="blackAlpha"
        textDecor="underline"
        flexDir={isSmDown ? 'column' : 'row'}
      >
        <Button
          onClick={() => sendForgotPasswordEmail(customer?.email)}
          isLoading={isLoading}
          loadingText="Sending reset email..."
        >
          Reset your password
        </Button>
        <Button onClick={logOut}>Log out</Button>
        <Button
          onClick={() =>
            alertDispatch({
              type: 'OPEN_ALERT',
              payload: {
                alertKey: EAlertTypes.DELETE_ACCOUNT,
                isCloseOnOutsideClick: false,
                alertContext: [logOut],
              },
            })
          }
        >
          Delete account
        </Button>
      </ButtonGroup>
    </Center>
  );
};
